import { Text } from "@meditect/medibase-components";

export const DeliveriesDeliveryWithThisIdentifierAlreadyExistsError = (): React.ReactElement => {
  return <Text>Cette réception ne peut pas être créée car une réception avec ce numéro de réception existe déjà.</Text>;
};
